import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core';
import { DragSource } from 'react-dnd';
import { compose } from '../../../utility';
import CheckboxIcon from '../../../assets/checkbox.svg';
import c from '../../constants';
import styles from './checkbox.styles';
import { checkboxPreview } from './dragPreview';

const checkboxSource = {
  beginDrag(props) {
    const { id, pageId } = props;
    return { id, pageId };
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview(),
  };
}

type PropType = {
  connectDragPreview: Function,
  classes: Object,
  connectDragSource: Function,
  handleClick: Function,
  handleKeyDown: Function,
}

class CheckboxC extends React.PureComponent<PropType, *> {

  componentDidMount() {
    const preview = new Image();
    preview.src = checkboxPreview;
    preview.onload = () => this.props.connectDragPreview && this.props.connectDragPreview(preview, { offsetX: 0, offsetY: 0 });
  }

  render() {
    const {
      classes, connectDragSource, handleClick, handleKeyDown,
    } = this.props;
    return connectDragSource && connectDragSource((
      <div
        role="button"
        tabIndex="0"
        onClick={ev => handleClick(ev, c.ItemTypes.CHECKBOX)}
        onKeyDown={ev => handleKeyDown(ev, c.ItemTypes.CHECKBOX)}
        className={classNames(classes.root, 'fieldOutClick')}
        data-testid="checkboxTool"
      >
        <CheckboxIcon />
        <span className={classes.legend}>Checkbox</span>
      </div>
    ));
  }

}

export const Checkbox = compose(
  DragSource(c.ItemTypes.CHECKBOX, checkboxSource, collect),
  withStyles(styles, { withTheme: true }),
)(CheckboxC);
